/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class PrescriptionRequest extends MainRequest{

    static addPrescription(data) {
        return this.postSEC(ServicePath.PRESCRIPTION_ADD, data);
    }

    static listAllPrescriptions(token) {
        return this.getSEC(ServicePath.PRESCRIPTION_LIST_ALL);
    }

    static updatePrescription(data, token) {
        return this.postSEC(ServicePath.PRESCRIPTION_UPDATE, data);
    }

    static deletePrescription(data, token) {
        return this.postSEC(ServicePath.PRESCRIPTION_DELETE, data);
    }    
    
    static listAllPrescriptionByStatus(data, token) {
        return this.postSEC(ServicePath.PRESCRIPTION_LIST_ALL_BY_STATUS, data);
    }

    static listAllPrescriptionByStatusPaged(data) {
        return this.postSEC(ServicePath.PRESCRIPTION_LIST_ALL_BY_STATUS_PAGED, data);
    }     
    
    static dispensePrescription(data) {
        return this.postSEC(ServicePath.PHARMACY_PRESCRIPTION_DISPENSE, data);
    }

    static updateStatus(data) {
        return this.postSEC(ServicePath.PHARMACY_PRESCRIPTION_UPDATE_STATUS, data);
    }

    static saveStockPrescription(data) {
        return this.postSEC(ServicePath.STOCK_PRESCRIPTION_SAVE, data);
    }
    static deleteStockPrescription(data) {
        return this.postSEC(ServicePath.STOCK_PRESCRIPTION_DELETE, data);
    }

}